import React from 'react';
import './App.scss';
import AppRouter from './AppRouter';
import { API_HOST, API_PORT } from './config/constants';

export const TREASURY_API_BASE = `${API_HOST}:${API_PORT}`;


export function App() {
    return <AppRouter />;
}
